import {
  TNaerasBid,
  TNaerasCalendar,
  TNaerasDashboard,
  TNaerasJobRun,
  TNaerasPoolState,
  TNaerasSettings,
} from "@/data/types";
import { State } from "../state/state";

export const getNaerasCalendar = (state: State): TNaerasCalendar | null =>
  state.naeras.calendar;

export const getNaerasBidsMap = (state: State): Record<string, TNaerasBid> =>
  state.naeras.bids;

export const getNaerasBidByDate = (date: string) => (state: State): TNaerasBid | null =>
  state.naeras.bids[date] ?? null;

export const getAllNaerasBids = (state: State): TNaerasBid[] => state.naeras.items;

export const getNaerasPool = (state: State): TNaerasPoolState | null => state.naeras.pool;

export const getNaerasJobRuns = (state: State): TNaerasJobRun[] => state.naeras.jobRuns;

export const getNaerasTodayJobRuns = (state: State): TNaerasJobRun[] =>
  state.naeras.todayRuns;

export const getNaerasJobRunsCursor = (state: State): string | null =>
  state.naeras.jobRunsCursor;

export const getNaerasDashboard = (state: State): TNaerasDashboard | null =>
  state.naeras.dashboard;

export const getNaerasSettings = (state: State): TNaerasSettings | null =>
  state.naeras.settings;
